import BaseModel from '../base/BaseModel.model';
import { ProposalState } from '@/enums/ProposalState';
import ResearchCenter from '../research/ResearchCenter/reseachCenter.model';
import PorposalUserReportEvaluations from './porposalUserReportEvaluations.model';
import Porposal from './porposal.model';
import PorposalBudgetItem from './porposalBudgetItem.model';
import ProposalDisbursement from './proposalDisbursement.model';
import { ProjectState } from '@/enums/projectState';
import { ReportEvaluationStateValidation } from '@/enums/ReportEvaluationStateValidation';
import ProposalBudgetItemExecution from './proposalBudgetItemExecution.model';
export default class ProposalUserReport extends BaseModel {

    public description?:string;
    public reason?:string;
    public stateDescription?:string;
    public proposalName?:string;
    public proposalCode?:string;
    public technicalScientistObservation?:string = '';
    public financialCharacterObservation?:string = '';
    public announcementTitle?:string;
    public documentTitle?:string;
    public documentId?:number;
    public proposalDisbursementId?:number;
    public proposalHistoricPercentDoneScheduleGanttId ?:number | null;
    public projectEndDocumentId?:number | null = null;
    public proposalId?:number;
    public budgetNotExecuted?:number;
    public closingBudget?:number;
    public budgetExecuted?:number;
    public totalDisbursementAmount?:number;
    public userId?:number;
    public order?:number;
    public remainingApprovedBudget?:number;
    public totalBudgetFondocyt?:number;
    public state: ProposalState | null;
    public document: any;
    public projectEndDocument: any = null;
    public researchCenter: ResearchCenter = null;
    public porposalUserReportEvaluations: Array<PorposalUserReportEvaluations> = [];
    public proposalBudgetItemsExecution: Array<ProposalBudgetItemExecution> = [];
    public isLastResport?: boolean;
    public firstDisbursementDate?: Date;
    public proposalStartDate?: Date;
    public proposalEndDate?: Date;
    public porposalBudgetItems: Array<PorposalBudgetItem> = [];
    public proposalDisbursementDocument: any | null = null;
    public projectState: ProjectState = null;
    public startPeriod?: Date | null;
    public endPeriod?: Date | null;
    public totalAmountSpent?: number | null;
    public allEvaluationsAreCompleted:boolean;
    public generalReportEvaluationsState: ReportEvaluationStateValidation = null;
    public generalBudgetExecutionEvaluationsState: ReportEvaluationStateValidation = null;
    public endProyectDate?: Date | null;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.documentId = 0;
        this.state = ProposalState.Creado;
        this.startPeriod = null;
        this.endPeriod = null;
        this.totalAmountSpent = 0;
    }
}